export const SUPPORT_USER_EMAIL_DOMAIN = '@pigello.se';
